import { default as mergeData } from '../../utilities/mergeSingleDataIntoArray';
import * as Constants from '../constants/';

const initialState = {
  isLoading: false,
  error: null,
  data: {
    imports: {
      DeImport: []
    },
    lastDeImport: {}
  }
};

export function lastSync(deImports) {
  const sorted = deImports.sort((a, b) => {
    return new Date(a.updated_at) > new Date(b.updated_at) ? -1 : 1;
  });
  return sorted.length > 0 ? sorted[0] : null;
}

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_IMPORTS:
      return { ...state, isLoading: true };
    case Constants.RECEIVE_IMPORTS:
      if (action.error) {
        return { ...state, isLoading: false, error: action.error };
      }
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          imports: action.data.imports,
          lastDeImport: action.data.imports.DeImport
            ? lastSync(action.data.imports.DeImport)
            : null
        }
      };
    case Constants.RECEIVE_UPDATED_IMPORT:
      const importType = action.data.import.type;
      return {
        ...state,
        isLoading: false,
        data: mergeData(
          state.data,
          { [importType]: action.data.import },
          `imports.${importType}`,
          importType,
          'import_id'
        )
      };
    default:
      return state;
  }
}
